import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "./App";
import CartProvider from "./context/cart_context";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
    <HashRouter>
    <CartProvider>
      <App />
        <ToastContainer position="bottom-right" />
      </CartProvider>
    </HashRouter>
  // </React.StrictMode>
);
